<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="clientData;"
           class="margin-bottom">
    <div class="row">
      <div class="col-md-12">
        <button class='btn btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <img src="{{ clientData?.logoUrl }}"
             class="logo"
             alt="">
        <h1>{{ clientData?.name}}</h1>
        <h2>Component Themes</h2>

      </div>
    </div>
    <div class="row sm-padding-top"
         *ngIf="clientData">

      <div class="col-md-3">
        <label for="primaryHex">Primary Hex Code</label>
      </div>
      <div class="col-md-3">
        <div class="color-block"
             [ngStyle]="{'background': clientData?.primaryHex}"></div>
        <p-inputMask id="primaryHex"
                     mask="#******"
                     placeholder="#e3e3e3"
                     [(ngModel)]="clientData.primaryHex"></p-inputMask>
      </div>
      <div class="col-md-3">
        <label for="accentHex">Accent Hex Code</label>
      </div>
      <div class="col-md-3">
        <div class="color-block"
             [ngStyle]="{'background': clientData?.accentHex}"></div>
        <p-inputMask id="accentHex"
                     mask="#******"
                     placeholder="#e3e3e3"
                     [(ngModel)]="clientData.accentHex"></p-inputMask>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center margin-top">
        <div class="btn-group"
             dropdown>
          <button dropdownToggle
                  type="button"
                  class="btn btn-primary btn-lg dropdown-toggle">
            Button dropdown
          </button>
          <ul *dropdownMenu
              class="dropdown-menu"
              role="menu">
            <li role="menuitem"
                *ngFor="let theme of themes">
              <a class="dropdown-item"
                 href="#">{{theme.name}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>


  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-themes/component-themes.component.html